import { commitMutation, graphql } from 'react-relay';
import environment from '../../../../environment';

const mutation = graphql`
  mutation savePickemAnswerMutation($input: savePickemAnswerInput!) {
    savePickemAnswer(input: $input) {
      code
      message
      data {
        _id
        correct_answer_count
        questions_answered
      }
    }
  }
`;

/**
 *
 * @param {Object} data
 * @param {Number} callback
 */
function savePickemAnswer(data, callback) {
  const variables = {
    input: {
      pickemAnswerInput: data,
    },
  };

  commitMutation(environment, {
    mutation,
    variables,
    onCompleted: (response, errors) => {
      callback(response);
    },
    onError: err => console.error(err),
  });
}

export default savePickemAnswer;
